import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CancelIcon from "@mui/icons-material/Cancel";
import Grid from "@mui/material/Grid";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Link } from "react-router-dom";

export default function AlertSaldoNegativo(props) {
  const errorSymp = props.errorSymp;
  const valeType = props.valeType;
  const tope = props.tope;
  const cantidad = props.cantidad;
  const textoConsumir = props.textoConsumir;
  const [valesCont] = useState(false || props.valesCont);
  const [consumir] = useState(false || props.consumir);
  const [button] = useState(false || props.button);
  const [open, setOpen] = useState(false || props.open);

  useEffect(() => {
    try {
      //redirect();
    } catch (err) {}
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div>
        {button == true && (
          <Button
            variant="contained"
            style={{
              width: "100%",
              marginBottom: "1%",
              marginTop: "1%",
              textTransform: "none",
              backgroundColor: props.color,
              color: "white",
            }}
            onClick={handleClickOpen}
          >
            {props.texto}
          </Button>
        )}

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogActions style={{ backgroundColor: "#424949" }}>
            {tope == cantidad && (
              <Button onClick={handleClose} color="primary">
                <CancelIcon style={{ color: "white" }} />
              </Button>
            )}{" "}
            {tope != cantidad && (
              <Link
                onClick={() => localStorage.setItem("valeType", valeType)}
                to="/vale"
                style={{ textDecoration: "none" }}
              >
                <CancelIcon style={{ color: "white" }} />
              </Link>
            )}
          </DialogActions>
          <DialogTitle id="alert-dialog-title">
            <Grid container>
              <Grid size={3}>
                {errorSymp == true && (
                  <ErrorRoundedIcon
                    color="secondary"
                    style={{
                      fontSize: "70px",
                      marginTop: "13%",
                      marginLeft: "10%",
                    }}
                  />
                )}
              </Grid>
              {valesCont == true && (
                <Grid size="grow">
                  {cantidad <= tope
                    ? "No hay saldo suficiente para generar este vale. Solicitá por e-mail a tu Oficina Comercial la recarga de saldo."
                    : "Advertimos que tu saldo está en negativo. Solicitá por e-mail a tu Oficina Comercial la recarga de los Vales."}
                </Grid>
              )}

              {consumir == true && textoConsumir}
            </Grid>
          </DialogTitle>
        </Dialog>
      </div>
    </div>
  );
}
